import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Siren, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

const OPEN = ["Needs Help", "Rescue Underway", "Partially Safe"];

// Always-visible homepage strip pointing to Urgent Rescues. Only published
// alerts are ever counted or linked — drafts never leak here.
export default function HomeRescueBanner() {
  const [open, setOpen] = useState([]);
  useEffect(() => {
    api.get("/urgent-rescues").then(({ data }) => setOpen((data.items || []).filter((r) => OPEN.includes(r.status)))).catch(() => {});
  }, []);
  const one = open.length === 1 ? open[0] : null;
  const to = one ? `/urgent-rescues/${one.id}` : "/urgent-rescues";
  const text = one
    ? `URGENT: ${one.title} — rescues & fosters needed`
    : open.length > 1
      ? `${open.length} urgent rescues need help right now`
      : "Urgent Rescue Alerts — animals in immediate need. Rescues, fosters & volunteers: see how you can help";
  return (
    <Link to={to} className="block bg-red-600 hover:bg-red-700 text-white transition-colors" data-testid="home-rescue-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center gap-3">
        <Siren size={20} className="shrink-0 animate-pulse" />
        <span className="font-display font-black uppercase tracking-tight text-sm sm:text-base flex-1" data-testid="home-rescue-banner-text">{text}</span>
        <span className="hidden sm:inline-flex items-center gap-1 text-xs font-bold uppercase tracking-widest border border-white px-3 py-1.5 shrink-0">
          View alerts <ArrowRight size={12} />
        </span>
      </div>
    </Link>
  );
}
